import { type Currency, CURRENCIES } from "../lib/currency";

interface Props {
  value: Currency;
  onChange: (next: Currency) => void;
  className?: string;
}

/**
 * Tiny native <select> for currency override. Native on purpose — it matches
 * OS styling (accessibility wins) and adds zero JS weight.
 */
export function CurrencyPicker({ value, onChange, className = "" }: Props) {
  return (
    <label
      className={`inline-flex items-center gap-2 text-xs text-ink/50 dark:text-paper/50 ${className}`}
    >
      <span className="font-mono uppercase tracking-wider">Moeda</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as Currency)}
        className="bg-transparent border border-ink/15 dark:border-paper/15 rounded-full px-3 py-1
                   text-ink dark:text-paper font-mono text-xs
                   focus:outline-none focus:border-ink/40 dark:focus:border-paper/40"
      >
        {Object.values(CURRENCIES).map((c) => (
          <option key={c.code} value={c.code} className="text-ink">
            {c.code} — {c.symbol}
          </option>
        ))}
      </select>
    </label>
  );
}
